import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IPosition, IPositionRoleCategory, IWorkType } from './interfaces';

export const getPositionList = (data: IDynamicTableParams) => {
  return instance()
    .post<IPosition[]>(`/position/list`, data)
    .then((response) => response.data);
};

export const getPositionAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>(`/position/availableColumns`)
    .then((response) => response.data);
};

export const getPositionAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>(`/position/availableGroupColumns`)
    .then((response) => response.data);
};

export const loadPosition = (positionId: number) => {
  return instance()
    .post<IPosition>('/position/load', { positionId })
    .then((response) => response.data);
};

export const createPosition = (position: IPosition) => {
  return instance()
    .post<IPosition>('/position/save', position)
    .then((response) => response.data);
};

export const updatePosition = (position: IPosition) => {
  return instance()
    .post<IPosition>(`/position/update`, position)
    .then((response) => response.data);
};

export const archivePosition = (positionId: number) => {
  return instance()
    .post('/position/delete', { positionId })
    .then((response) => response.data);
};

export const recoverPosition = (positionId: number) => {
  return instance()
    .post('/position/recover', { positionId })
    .then((response) => response.data);
};

// Dictionaries
export const getAdminPositions = (data?: { headPositionId?: number | null }) => {
  return instance()
    .post<IPosition[]>('/dictionary/adminPositions', data)
    .then((response) => response.data);
};

export const getPositionRoleCategories = () => {
  return instance()
    .post<IPositionRoleCategory[]>('/dictionary/adminRoles')
    .then((response) => response.data);
};

export const getWorkTypes = () => {
  return instance()
    .post<IWorkType[]>('/dictionary/workTypes/list')
    .then((response) => response.data);
};
